export default __webpack_public_path__ + "static/media/activity05.79cf22c9.jpg";